import { useEffect } from 'react';

export default function useVersionCheck() {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        // Ajoutez un timestamp pour éviter le cache de cette requête
        const response = await fetch(`/version.json?t=${Date.now()}`);
        if (!response.ok) return;
        
        const data = await response.json();
        const serverVersion = data.version;
        const localVersion = localStorage.getItem('appVersion');
        
        console.log(`Version serveur: ${serverVersion}, Version locale: ${localVersion || 'non définie'}`);
        
        // Si pas de version locale ou si différente
        if (!localVersion || localVersion !== serverVersion) {
          // Stocker la nouvelle version
          localStorage.setItem('appVersion', serverVersion);
          
          // Si ce n'est pas le premier chargement (version locale existe)
          if (localVersion) {
            console.log(`Nouvelle version détectée! Rechargement de l'application...`);
            // Recharger l'application
            window.location.reload(true);
          }
        }
      } catch (error) {
        console.error("Erreur lors de la vérification de version:", error);
      }
    };
    
    // Vérifier au démarrage
    checkVersion();
    
    // Puis toutes les 15 minutes 
    const interval = setInterval(checkVersion, 15 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);
}